export default {
  fields: {
    demo: {
      label: 'Crea demo',
    },
    ai: {
      label: 'Ottimizzato con AI',
    },
    restaurant_type: {
      label: 'Seleziona tipo di ristorante',
      types: {
        Pizza: 'Pizza 🍕',
        PizzaDelivery: 'Pizza a domicilio 🍕🚗',
        PizzaNeapolitan: 'Pizza napoletana 🍕',
        Italian: 'Italiano 🇮🇹',
        Burger: 'Burger 🍔',
        Turkish: 'Turco 🇹🇷',
        Mexican: 'Messicano 🌮',
        Sushi: 'Sushi 🍱',
        Japanese: 'Giapponese 🇯🇵',
        Vietnamese: 'Vietnamita 🇻🇳',
        Thai: 'Tailandese 🇹🇭',
        Asian: 'Asiatico 🍜',
        Indian: 'Indiano 🥘',
        Bowls: 'Bowls 🥣',
        Vegan: 'Vegano 🥑',
        Greek: 'Greco 🏛️',
        Cafe: 'Caffè ☕️',
        Brunch: 'Brunch 🍵',
        Oriental: 'Orientale / Medio Oriente 🧆',
        Spanish: 'Spagnolo / Tapas 🇪🇸',
        Persian: 'Persiano 🫖',
      },
    },
    plugins: {
      reservations: 'Prenotazioni',
      reservations_plan_hint:
        'Le prenotazioni richiedono un Partner Plan. Ti verrà chiesto di attivarlo per {{name}} quando crei il sito web.',
      catering: 'Catering',
      events: 'Eventi',
    },
    quarter: {
      label: 'Quartiere',
      address_placeholder: 'Inserisci indirizzo',
      quarter_placeholder: 'Inserisci quartiere',
    },
    delivery_areas: {
      label: 'Quali zone servi in città?',
      city_placeholder: 'Inserisci città',
      district_placeholder: 'Quartiere 1, Quartiere 2, Quartiere 3',
    },
    best_dishes: {
      label: 'Quali sono i tuoi 3 piatti principali?',
      placeholder: 'Inserisci piatti (Chicken burger, Cheese burger, ecc.)',
    },
    dietary_attributes: {
      label: 'Hai opzioni per chi vuole mangiare:',
      placeholder: 'Seleziona preferenze alimentari',
      types: {
        vegetarian: 'Vegetariano',
        vegan: 'Vegano',
        halal: 'Halal',
        gluten_free: 'Senza glutine',
        dairy_free: 'Senza lattosio',
        spicy: 'Piccante',
      },
    },
    family_owned: {
      label: 'A gestione familiare?',
      yes: 'Sì',
      no: 'No',
    },
    business_founding_year: {
      label: 'Quando è stato fondato il ristorante (anno)?',
    },
    business_owners: {
      label: 'Titolari',
      placeholder: 'Inserisci titolare',
    },
    notes: {
      label: 'Aggiungi note aggiuntive (opzionale)',
      placeholder: 'Es. ristorante orientato alla comunità, iniziative, gestione di coppia...',
    },
    about_us: {
      title: 'Chi siamo (Anteprima)',
    },
  },
  sections: {
    plugins: 'Plugin',
    company_info: 'Genera info azienda',
  },
  buttons: {
    find_district: 'Trova quartiere',
    generate: 'Genera',
    products: 'Prodotti',
    add: 'Aggiungi',
  },
};
